import { apiSlice } from "./apiSlice";

export const designEngineeringSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllDesignEng: builder.query({
            query: (params) => ({
                url: `DesignTracker`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["DesignTracker"],
        }),

        // Export all data (without pagination) in Excel File
        getExportAllDesignEng: builder.query({
            query: (params) => ({
                url: `DesignTracker`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

        getDesignEngById: builder.query({
            query: (designTrackerId, params) => ({
                url: `DesignTracker/${designTrackerId}`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["DesignTracker"],
        }),



        getDesignEngStatusCount: builder.query({
            query: (params) => ({
                url: `DesignTracker/status/counts`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),

        createDesignEng: builder.mutation({
            query: ({ body }) => ({
                url: `DesignTracker`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["DesignTracker"],
        }),

        updateDesignEng: builder.mutation({
            query: ({ body }) => ({
                url: `DesignTracker`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["DesignTracker"],
        }),

        getDesignEngComment: builder.query({
            query: ({ designTrackerId, ...params }) => ({
                url: `DesignTracker/${designTrackerId}/comments`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["CommentList"]
        }),

        addDesignEngComment: builder.mutation({
            query: (formData) => ({
                url: `DesignTracker/comments`,
                method: "POST",
                body: formData,
            }),
            invalidatesTags: ["CommentList"],
        }),
        updateDesignEngComments: builder.mutation({
            query: ({ body }) => ({
                url: `DesignTracker/comments`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["CommentList"],
        }),

        getDesignEngAttachmentsByComment: builder.query({
            query: (commentId) => `/DesignTracker/${commentId}/attachments`,
        }),
        initiateRFI: builder.mutation({
            query: (designTrackerId) => ({
                url: `DesignTracker/${designTrackerId}/initiate-workflow`,
                method: "PUT",
            }),
            invalidatesTags: ["DesignTracker"],
        }),

    }),
});

export const {
    useGetAllDesignEngQuery,
    useCreateDesignEngMutation,
    useAddDesignEngCommentMutation,
    useGetDesignEngAttachmentsByCommentQuery,
    useUpdateDesignEngMutation,
    useGetDesignEngStatusCountQuery,
    useLazyGetAllDesignEngQuery,
    useGetDesignEngCommentQuery,
    useGetDesignEngByIdQuery,
    useLazyGetDesignEngByIdQuery,
    useInitiateRFIMutation,
    useLazyGetExportAllDesignEngQuery

} = designEngineeringSlice;